<template>
  <v-flex xs6 sm5>
    <v-select
      v-model="ordination"
      :items="items"
      item-text="text"
      item-value="value"
      label="Ordenação"
      persistent-hint
      return-object
      single-line
    ></v-select>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      items: [
        { text: "Mais recente", value: "created_at_desc" },
        { text: "Mais antigo", value: "created_at_asc" },
        { text: "Maior valor", value: "amount_desc" },
        { text: "Menor valor", value: "amount_asc" },
        { text: "Nome do pagador (A-Z)", value: "payer_name_asc" },
        { text: "Nome do pagador (Z-A)", value: "payer_name_desc" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      storeOrdination: "bills/filtersOrdination"
    }),
    ordination: {
      get() {
        return this.storeOrdination;
      },
      set(newOrdination) {
        this.$store.dispatch("bills/setOrdination", newOrdination.value);
      }
    }
  }
};
</script>